module.exports = __webpack_public_path__ + "img/sanofi.7f70bace.png";